import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { googleAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const result = await googleAuth(sessionId);
        window.history.replaceState(null, '', window.location.pathname);
        if (result?.status === 'pendente' || result?.status === 'inativo') {
          navigate('/login', { replace: true, state: { message: result.message } });
        } else {
          const dest = (result?.role === 'admin' || result?.role === 'nutricionista') ? '/admin/dashboard' : '/dashboard';
          navigate(dest, { replace: true });
        }
      } catch (err) {
        console.error('Google auth error:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg">
      <div className="animate-pulse text-brand-green font-heading text-xl" data-testid="auth-callback-loading">
        A autenticar...
      </div>
    </div>
  );
}
